import { useEffect, useMemo } from "react";

export function useBodyClass(classes) {
    const classesArray = useMemo(() => classes.split(' '), [classes]);

    useEffect(() => {
        if (!classes) return;

        document.body.classList.add(...classesArray);
        return () => {
            document.body.classList.remove(...classesArray);
        }
    }, [classesArray, classes])
}